var _rect, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCertification(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 62,
    viewBox: "0 0 62 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 15.0293,
    y: 0.606445,
    width: 48,
    height: 48,
    rx: 10,
    transform: "rotate(15 15.0293 0.606445)",
    fill: "#36BFFA"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_42892_4004)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 14,
    width: 48,
    height: 48,
    rx: 10,
    fill: "white",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 14.5,
    width: 47,
    height: 47,
    rx: 9.5,
    stroke: "white",
    strokeOpacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29 40.4996V37.494C29 37.3145 29 37.2248 28.9727 37.1456C28.9485 37.0755 28.9091 37.0117 28.8572 36.9587C28.7986 36.8989 28.7183 36.8587 28.5578 36.7785L24 34.4996M16 35.4996V42.3062C16 42.6781 16 42.8641 16.058 43.0269C16.1093 43.1708 16.1929 43.3011 16.3024 43.4077C16.4262 43.5283 16.5953 43.6057 16.9334 43.7607L23.3334 46.694C23.5786 46.8064 23.7012 46.8626 23.8289 46.8848C23.9421 46.9045 24.0579 46.9045 24.1711 46.8848C24.2988 46.8626 24.4214 46.8064 24.6666 46.694L31.0666 43.7607C31.4047 43.6057 31.5738 43.5283 31.6976 43.4077C31.8071 43.3011 31.8907 43.1708 31.942 43.0269C32 42.8641 32 42.6781 32 42.3062V35.4996M14 34.4996L23.6422 29.6785C23.7734 29.6129 23.839 29.5801 23.9078 29.5672C23.9687 29.5557 24.0313 29.5557 24.0922 29.5672C24.161 29.5801 24.2266 29.6129 24.3578 29.6785L34 34.4996L24.3578 39.3207C24.2266 39.3863 24.161 39.4191 24.0922 39.432C24.0313 39.4434 23.9687 39.4434 23.9078 39.432C23.839 39.4191 23.7734 39.3863 23.6422 39.3207L14 34.4996Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_42892_4004",
    x: -16,
    y: -2,
    width: 80,
    height: 80,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_42892_4004"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_42892_4004",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCertification);
export default __webpack_public_path__ + "static/media/certification.ae7dd2a0380e2b36895ea7dbf70ac4fc.svg";
export { ForwardRef as ReactComponent };